import TeamsTableRow from './TeamsTableRow/TeamsTableRow';
import TeamsTableHeader from './TeamsTableHeader';
import { ColumnWidths } from './TeamsTable.constants';
import type { TableRowData } from './TeamsTable.types';

interface TeamsTableProps {
  /** Additional CSS classes to apply to the row container. */
  className?: string;
  /** Array of team data to display in the table rows */
  rowData: TableRowData[];
  /** Whether to display the recent form column in the table */
  shouldDisplayFormColumn?: boolean;
}

export default function TeamsTable({
  className = '',
  rowData,
  shouldDisplayFormColumn = false,
}: TeamsTableProps) {
  const gridTemplateColumns = [
    ColumnWidths.COLOR,
    ColumnWidths.POSITION,
    ColumnWidths.TEAM_NAME,
    ColumnWidths.MATCHES_PLAYED,
    ColumnWidths.WINS,
    ColumnWidths.DRAWS,
    ColumnWidths.LOSSES,
    ColumnWidths.POINTS,
    ...(shouldDisplayFormColumn ? [ColumnWidths.RECENT_FORM] : []),
  ];
  const columnCount = gridTemplateColumns.length;

  return (
    <div
      className={`grid gap-x-1 ${className}`}
      style={{ gridTemplateColumns: gridTemplateColumns.join(' ') }}
    >
      <TeamsTableHeader shouldDisplayFormColumn={shouldDisplayFormColumn} />
      {rowData.map((row, index) => {
        const isFirstRow = index === 0;
        return (
          <TeamsTableRow
            key={row.teamName}
            {...row}
            columnCount={columnCount}
            isFirstRow={isFirstRow}
            shouldDisplayFormColumn={shouldDisplayFormColumn}
          />
        );
      })}
    </div>
  );
}
